export default __webpack_public_path__ + "static/media/close-icon.2800e407.svg";